import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";

const BarLineChart = ({ data, isHourly, setIsHourly, Heading }) => {
  const [categories, setCategories] = useState([]);
  const [barData, setBarData] = useState([]);
  const [lineData, setLineData] = useState([]);
  const [dataZoomEnabled, setDataZoomEnabled] = useState(true);
  const [dataZoomEnd, setDataZoomEnd] = useState();

  useEffect(() => {
    if (data.length > 0) {
      const newCategories = data.map((item) => {
        if (item.key_as_string) {
          const datePart = item.key_as_string.split(" ")[0];
          // console.log(datePart, "date");
          const timePart = item.key_as_string.split(" ")[1];
          // console.log(timePart, "time");
          return isHourly ? timePart.split(":")[0] : datePart.split("-").pop();
        }
        return "";
      });

      const newBarData = data.map((item) => item.daily_sum?.value || 0);
      const newLineData = data.map((item) => item.Cumulative_sum?.value || 0);
      setCategories(newCategories);
      setBarData(newBarData);
      setLineData(newLineData);
    }
  }, [data, isHourly]);

  useEffect(() => {
    const handleResize = () => {
      // Check screen width and disable dataZoom on smaller screens
      const width = window.innerWidth;
      if (width > 640) {
        setDataZoomEnabled(false);
        setDataZoomEnd(100);
      } else {
        setDataZoomEnabled(true);
        setDataZoomEnd(30);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial call to set dataZoom based on current screen size

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleData = () => {
    setIsHourly((prev) => !prev);
  };

  const options = {
    title: {
      text: isHourly ? "Hour Wise " + Heading : "Day Wise " + Heading,
      left: "left",
      textStyle: {
        fontFamily: "Uni Neue",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    tooltip: {
      trigger: "axis",
    },
    legend: {
      show: false,
    },
    grid: {
      top: "25%",
      left: "3%",
      right: "3%",
      bottom: "3%",
      containLabel: true,
    },

    dataZoom: [
      {
        type: "slider",
        show: dataZoomEnabled,
        xAxisIndex: [0],
        filterMode: "filter",
        height: 10,
        backgroundColor: "#ccc",
        handleColor: "#2A5775",
        handleSize: 5,
        showDetail: false,
        fillerColor: "#2A5775",
        zoomOnMouseWheel: false,
        moveOnMouseMove: false,
        moveOnMouseWheel: false,
        zoomLock: true,
        start: 0,
        end: dataZoomEnd,
        bottom: 0,
      },
      ,
    ],

    xAxis: {
      type: "category",
      boundaryGap: true,
      data: categories,
      axisLabel: {
        interval: 0,
      },
    },
    yAxis: [
      {
        type: "value",
        scale: true,
        position: "left",
        splitLine: {
          show: false,
        },
      },
      {
        show: false,
        type: "value",
        scale: true,
        position: "right",
        splitLine: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: isHourly ? "Hourly Sum" : "Daily Sum",
        type: "bar",
        data: barData,
        barWidth: "80%",
        itemStyle: {
          color: isHourly ? "#AAE0D3" : "#E0AABA",
        },
        yAxisIndex: 0,
        label: {
          show: true,
          position: "top",
        },
      },
      {
        name: "Cumulative Sum",
        type: "line",
        data: lineData,
        smooth: true,
        yAxisIndex: 1,
      },
    ],
  };

  return (
    <div className="relative">
      <ReactECharts option={options} style={{ height: 170 }} />

      <div className="absolute top-0 right-0 mr-2 flex items-center">
        <span className="mr-2 text-gray-700">
          {isHourly ? "Hourly" : "Daily"}
        </span>
        <label className="relative inline-block w-10 align-middle select-none">
          <input
            type="checkbox"
            checked={isHourly}
            onChange={toggleData}
            className="toggle-checkbox absolute block w-6 h-6 rounded-full appearance-none cursor-pointer border-2 border-transparent transition-transform duration-200"
          />
          <span
            className={`toggle-label block overflow-hidden h-6 rounded-full cursor-pointer ${
              isHourly ? "bg-[#AAE0D3]" : "bg-[#E0AABA]"
            }`}
          >
            <span
              className={`block h-5 w-5 rounded-full ${
                isHourly ? "bg-[#599f8e]" : "bg-pink-500"
              } shadow-md transform transition-transform duration-200 ${
                isHourly ? "translate-x-full" : "translate-x-0"
              } translate-y-0.5`}
            ></span>
          </span>
        </label>
      </div>
    </div>
  );
};

export default BarLineChart;
